<template>
<div class="left-bar">
	<div class="top">
		<img src="../../../../public/images/logo.png"/>
    <p>OIMS</p>
	</div>
  <el-menu
    background-color="#1a2a52"
    text-color="#eee"
    active-text-color="#4dbcff"
    :default-active="currentMenu"
    :unique-opened="true"
  >
    <dynamic-menu :menuList="sidebarMenu"></dynamic-menu>
  </el-menu>
</div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      isCollapse: true,
    };
  },
  computed: {
    ...mapState("permission", ["sidebarMenu", "currentMenu"]),
  },
  watch:{
  },
  methods: {},
  components: {
  },
};
</script>
<style lang="less">
.left-bar {
	width: 200px;
	background:#1a2a52;
	// background:#0b2048;
	height: 100vh;
  .top {
    display: flex;
    justify-content: center;
    /* padding: 20px 0 20px 0; */
    height: 50px;
    align-items: center;
    border-bottom: 1px solid rgba(255,255,255,0.1);
    img { 
      height: 28px;
      margin-right: 10px;
    }
    p {
      color: #fff;
    }
  }
}
</style>
